/**
 * @generated SignedSource<<c78edf816bb0e32c61021a0d8a256f02>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef";
};
export type atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef$key = {
  readonly " $data"?: atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraTownsquareProjectField"
};

(node as any).hash = "a65462d58befdde3cf6398f90e5e70ca";

export default node;
